(function () {
  if (window.SuedpolBilderbuchkinoModalLoaded) {
    return;
  }

  window.SuedpolBilderbuchkinoModalLoaded = true;

  const focusableSelector = [
    'a[href]',
    'button:not([disabled])',
    'textarea:not([disabled])',
    'input:not([disabled])',
    'select:not([disabled])',
    '[tabindex]:not([tabindex="-1"])'
  ].join(',');

  let activeModal = null;
  let lastFocusedElement = null;
  let globalListenersBound = false;
  let savedScrollY = 0;

  function ready(callback) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', callback);
    } else {
      callback();
    }
  }

  function getFocusableElements(container) {
    return Array.from(container.querySelectorAll(focusableSelector)).filter(function (element) {
      return !!(
        element.offsetWidth ||
        element.offsetHeight ||
        element.getClientRects().length
      );
    });
  }

  function setMessage(form, message, type) {
    const messageBox = form.querySelector('[data-bbk-message]');

    if (!messageBox) {
      return;
    }

    messageBox.textContent = message || '';
    messageBox.classList.remove('bbk-message--success', 'bbk-message--error');

    if (type) {
      messageBox.classList.add('bbk-message--' + type);
    }
  }

  function buildNoCacheUrl(url) {
    try {
      const parsedUrl = new URL(url, window.location.href);
      parsedUrl.searchParams.set('_bbk', String(Date.now()));
      return parsedUrl.toString();
    } catch (error) {
      const separator = url.indexOf('?') === -1 ? '?' : '&';
      return url + separator + '_bbk=' + Date.now();
    }
  }

  function moveModalToBody(modal) {
    if (!modal || modal.parentElement === document.body) {
      return;
    }

    document.body.appendChild(modal);
  }

  function focusWithoutScroll(element) {
    if (!element || typeof element.focus !== 'function') {
      return;
    }

    try {
      element.focus({
        preventScroll: true
      });
    } catch (error) {
      element.focus();
    }
  }

  function lockPageScroll() {
    savedScrollY = window.scrollY || window.pageYOffset || 0;

    document.documentElement.style.setProperty(
      '--bbk-scroll-lock-top',
      '-' + savedScrollY + 'px'
    );

    document.documentElement.classList.add('bbk-modal-is-open');
    document.body.classList.add('bbk-modal-is-open');
  }

  function unlockPageScroll() {
    document.documentElement.classList.remove('bbk-modal-is-open');
    document.body.classList.remove('bbk-modal-is-open');

    document.documentElement.style.setProperty('--bbk-scroll-lock-top', '0px');

    window.scrollTo({
      top: savedScrollY,
      left: 0,
      behavior: 'auto'
    });
  }

  function isFormFieldFocused() {
    const element = document.activeElement;

    if (!element) {
      return false;
    }

    return (
      element.tagName === 'INPUT' ||
      element.tagName === 'TEXTAREA' ||
      element.tagName === 'SELECT' ||
      element.isContentEditable
    );
  }

  function updateModalOffsets() {
    const headerSelectors = [
      '#shopify-section-header',
      '.shopify-section-header-sticky',
      '.shopify-section-header-hidden',
      'sticky-header',
      '.header-wrapper',
      'header.header',
      'header[role="banner"]'
    ];

    const footerSelectors = [
      '#shopify-section-footer',
      'footer.footer',
      '.footer',
      'footer[role="contentinfo"]'
    ];

    let headerOffset = 0;
    let footerOffset = 0;

    headerSelectors.forEach(function (selector) {
      const element = document.querySelector(selector);

      if (!element) {
        return;
      }

      const rect = element.getBoundingClientRect();

      if (
        rect.width > 0 &&
        rect.height > 0 &&
        rect.bottom > 0 &&
        rect.top < window.innerHeight
      ) {
        headerOffset = Math.max(headerOffset, Math.ceil(rect.bottom));
      }
    });

    footerSelectors.forEach(function (selector) {
      const element = document.querySelector(selector);

      if (!element) {
        return;
      }

      const rect = element.getBoundingClientRect();

      /*
        Footer wird nur berücksichtigt, wenn er gerade sichtbar in den Viewport ragt.
        Ist er nicht sichtbar, bleibt unten nur der normale 50px-Abstand.
      */
      if (
        rect.width > 0 &&
        rect.height > 0 &&
        rect.top < window.innerHeight &&
        rect.bottom > 0
      ) {
        footerOffset = Math.max(
          footerOffset,
          Math.ceil(window.innerHeight - rect.top)
        );
      }
    });

    document.documentElement.style.setProperty('--bbk-header-offset', headerOffset + 'px');
    document.documentElement.style.setProperty('--bbk-footer-offset', footerOffset + 'px');
  }

  function openModal(modal) {
    if (!modal) {
      return;
    }

    updateModalOffsets();
    moveModalToBody(modal);

    lastFocusedElement = document.activeElement;
    activeModal = modal;

    modal.hidden = false;
    modal.setAttribute('aria-hidden', 'false');

    lockPageScroll();

    const form = modal.querySelector('[data-bbk-form]');

    if (form) {
  setMessage(form, '', '');
  updateSubmitState(form);
  loadCaptcha(form, false);
}

    window.setTimeout(function () {
      const firstInput = modal.querySelector('input:not([type="hidden"]):not([tabindex="-1"])');
      const closeButton = modal.querySelector('[data-bbk-close]');
      const dialog = modal.querySelector('.bbk-modal__dialog');

      if (firstInput) {
        focusWithoutScroll(firstInput);
      } else if (closeButton) {
        focusWithoutScroll(closeButton);
      } else if (dialog) {
        focusWithoutScroll(dialog);
      }
    }, 30);
  }

  function closeModal(modal) {
    const modalToClose = modal || activeModal;

    if (!modalToClose) {
      return;
    }

    modalToClose.hidden = true;
    modalToClose.setAttribute('aria-hidden', 'true');

    unlockPageScroll();

    activeModal = null;

    document.documentElement.style.setProperty('--bbk-footer-offset', '0px');

    if (
      lastFocusedElement &&
      typeof lastFocusedElement.focus === 'function' &&
      document.contains(lastFocusedElement)
    ) {
      focusWithoutScroll(lastFocusedElement);
    }

    lastFocusedElement = null;
  }

  function trapFocus(event) {
    if (!activeModal || event.key !== 'Tab') {
      return;
    }

    const focusableElements = getFocusableElements(activeModal);

    if (!focusableElements.length) {
      event.preventDefault();
      return;
    }

    const firstElement = focusableElements[0];
    const lastElement = focusableElements[focusableElements.length - 1];

    if (event.shiftKey && document.activeElement === firstElement) {
      event.preventDefault();
      lastElement.focus();
    } else if (!event.shiftKey && document.activeElement === lastElement) {
      event.preventDefault();
      firstElement.focus();
    }
  }

  async function loadCaptcha(form, forceReload) {
    const captchaBox = form.querySelector('[data-bbk-captcha]');

    if (!captchaBox) {
      return;
    }

    const endpoint = captchaBox.getAttribute('data-bbk-captcha-endpoint');
    const questionElement = captchaBox.querySelector('[data-bbk-captcha-question]');
    const tokenInput = captchaBox.querySelector('[data-bbk-captcha-token]');
    const answerInput = captchaBox.querySelector('input[name="captcha_answer"]');

    if (!endpoint) {
      if (questionElement) {
        questionElement.textContent = 'Die Sicherheitsfrage ist nicht konfiguriert.';
      }

      if (answerInput) {
        answerInput.disabled = true;
      }

      return;
    }

    const loadedAt = Number(captchaBox.getAttribute('data-bbk-loaded-at') || 0);
    const isStillFresh = loadedAt && Date.now() - loadedAt < 25 * 60 * 1000;

    if (!forceReload && tokenInput && tokenInput.value && isStillFresh) {
      return;
    }

    if (questionElement) {
      questionElement.textContent = 'Sicherheitsfrage wird geladen …';
    }

    if (answerInput) {
      answerInput.value = '';
      answerInput.disabled = true;
    }

    if (tokenInput) {
      tokenInput.value = '';
    }

    try {
      const response = await fetch(buildNoCacheUrl(endpoint), {
        method: 'GET',
        mode: 'cors',
        credentials: 'omit',
        cache: 'no-store',
        headers: {
          Accept: 'application/json'
        }
      });

      let data = null;

      try {
        data = await response.json();
      } catch (jsonError) {
        throw new Error('Die Sicherheitsfrage konnte nicht gelesen werden.');
      }

      if (!response.ok || data.success === false || data.error) {
        throw new Error(
          data.message ||
          data.error ||
          'CAPTCHA konnte nicht geladen werden.'
        );
      }

      const question =
        data.question ||
        data.captcha_question ||
        data.label ||
        data.challenge;

      const token =
        data.token ||
        data.captcha_token;

      if (!question || !token) {
        throw new Error('CAPTCHA-Antwort ist unvollständig.');
      }

      if (questionElement) {
        questionElement.textContent = question;
      }

      if (tokenInput) {
        tokenInput.value = token;
      }

     if (answerInput) {
  answerInput.disabled = false;
}

captchaBox.setAttribute('data-bbk-loaded-at', String(Date.now()));

updateSubmitState(form);

    } catch (error) {
      if (questionElement) {
        questionElement.textContent = 'Die Sicherheitsfrage konnte nicht geladen werden.';
      }

      if (answerInput) {
        answerInput.disabled = true;
      }

      updateSubmitState(form);

      setMessage(
        form,
        'Die Sicherheitsfrage konnte nicht geladen werden. Bitte laden Sie die Seite neu oder versuchen Sie es später erneut.',
        'error'
      );

      if (window.console && typeof window.console.warn === 'function') {
        window.console.warn('[Bilderbuchkino] CAPTCHA konnte nicht geladen werden:', error);
      }
    }
  }

  function validateForm(form) {
    const privacyCheckbox = form.querySelector('input[name="contact[Datenschutz]"]');
    const captchaToken = form.querySelector('input[name="captcha_token"]');
    const captchaAnswer = form.querySelector('input[name="captcha_answer"]');

    if (!form.checkValidity()) {
      form.reportValidity();
      return false;
    }

    if (!privacyCheckbox || !privacyCheckbox.checked) {
      setMessage(form, 'Bitte akzeptieren Sie die Datenschutzerklärung.', 'error');

      if (privacyCheckbox) {
        privacyCheckbox.focus();
      }

      return false;
    }

    if (!captchaToken || !captchaToken.value || !captchaAnswer || !captchaAnswer.value.trim()) {
      setMessage(form, 'Bitte beantworten Sie die Sicherheitsfrage.', 'error');

      if (captchaAnswer) {
        captchaAnswer.focus();
      }

      return false;
    }

    return true;
  }

  function updateSubmitState(form) {
  const submitButton = form.querySelector('.bbk-submit');

  if (!submitButton) {
    return;
  }

  const contactName = form.querySelector('input[name="contact[Ansprechpartner]"]');
  const library = form.querySelector('input[name="contact[Bibliothek]"]');
  const email = form.querySelector('input[name="contact[E-Mail]"]');
  const privacy = form.querySelector('input[name="contact[Datenschutz]"]');
  const captchaAnswer = form.querySelector('input[name="captcha_answer"]');
  const captchaToken = form.querySelector('input[name="captcha_token"]');

  const emailIsValid = email && email.value.trim() !== '' && email.checkValidity();

  const isComplete =
    contactName &&
    contactName.value.trim() !== '' &&
    library &&
    library.value.trim() !== '' &&
    emailIsValid &&
    privacy &&
    privacy.checked &&
    captchaAnswer &&
    captchaAnswer.value.trim() !== '' &&
    captchaToken &&
    captchaToken.value.trim() !== '';

  submitButton.disabled = !isComplete;
}

  async function submitForm(form) {
    if (!validateForm(form)) {
      return;
    }

    const submitButton = form.querySelector('button[type="submit"]');
    const originalButtonText = submitButton ? submitButton.textContent : '';

    if (submitButton) {
      submitButton.disabled = true;
      submitButton.textContent = 'Wird gesendet …';
    }

    setMessage(form, '', '');

    try {
      const response = await fetch(form.action, {
        method: 'POST',
        body: new FormData(form),
        mode: 'cors',
        credentials: 'omit',
        headers: {
          Accept: 'application/json'
        }
      });

      let data = null;

      try {
        data = await response.json();
      } catch (jsonError) {
        throw new Error('Die Serverantwort konnte nicht gelesen werden.');
      }

      if (!response.ok || data.success === false) {
        const message =
          data.message ||
          'Die Anfrage konnte leider nicht gesendet werden. Bitte versuchen Sie es erneut.';

        setMessage(form, message, 'error');

        if (data.captcha_reload) {
          await loadCaptcha(form, true);
        }

        return;
      }

      const modal = form.closest('[data-bbk-modal]');
      const successMessage =
        data.message ||
        form.getAttribute('data-success-message') ||
        (modal ? modal.getAttribute('data-bbk-success-message') : '') ||
        'Vielen Dank. Ihre Anfrage wurde erfolgreich gesendet.';

      setMessage(form, successMessage, 'success');
form.reset();

updateSubmitState(form);

await loadCaptcha(form, true);
updateSubmitState(form);

      if (data.redirect) {
        window.setTimeout(function () {
          window.location.href = data.redirect;
        }, 700);
      }
    } catch (error) {
      setMessage(
        form,
        'Leider ist ein technischer Fehler aufgetreten. Bitte versuchen Sie es später erneut.',
        'error'
      );

      await loadCaptcha(form, true);
    } finally {
      if (submitButton) {
        submitButton.disabled = false;
        submitButton.textContent = originalButtonText;
      }
    }
  }

  function bindGlobalListeners() {
    if (globalListenersBound) {
      return;
    }

    globalListenersBound = true;

    document.addEventListener('click', function (event) {
      const openButton = event.target.closest('[data-bbk-open]');
      const closeButton = event.target.closest('[data-bbk-close]');
      const captchaReloadButton = event.target.closest('[data-bbk-captcha-reload]');

      if (openButton) {
        event.preventDefault();

        const modalId = openButton.getAttribute('data-bbk-open');
        const modal = document.getElementById(modalId);

        openModal(modal);
        return;
      }

      if (closeButton) {
        event.preventDefault();

        const modal = closeButton.closest('[data-bbk-modal]');
        closeModal(modal);
        return;
      }

      if (captchaReloadButton) {
        event.preventDefault();

        const form = captchaReloadButton.closest('form');

        if (form) {
          loadCaptcha(form, true);
        }
      }
    });

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && activeModal) {
        event.preventDefault();
        closeModal(activeModal);
        return;
      }

      trapFocus(event);
    });

    /*
      Resize nur berücksichtigen, wenn kein Formularfeld fokussiert ist.
      So verschiebt die mobile Tastatur das Popup nicht nach oben.
    */
    window.addEventListener('resize', function () {
      if (activeModal && !isFormFieldFocused()) {
        updateModalOffsets();
      }
    });

    window.addEventListener('orientationchange', function () {
      if (activeModal) {
        window.setTimeout(updateModalOffsets, 150);
      }
    });

    /*
      Kein visualViewport.resize:
      Mobile Tastaturen lösen visualViewport.resize aus.
      Dadurch würde das Popup nach oben springen.
      Die Tastatur darf das Popup bewusst überlagern.
    */
  }

  function initModals() {
    document.querySelectorAll('[data-bbk-modal]').forEach(function (modal) {
      moveModalToBody(modal);

      const form = modal.querySelector('[data-bbk-form]');
      const successMessage = form
        ? form.getAttribute('data-success-message')
        : '';

      if (successMessage) {
        modal.setAttribute('data-bbk-success-message', successMessage);
      }
    });

    document.querySelectorAll('[data-bbk-form]').forEach(function (form) {
      if (form.getAttribute('data-bbk-initialized') === 'true') {
        return;
      }

      form.setAttribute('data-bbk-initialized', 'true');

updateSubmitState(form);

form.addEventListener('input', function () {
  updateSubmitState(form);
});

form.addEventListener('change', function () {
  updateSubmitState(form);
});

form.addEventListener('submit', function (event) {
  event.preventDefault();
  submitForm(form);
});
    });
  }

  function init() {
    bindGlobalListeners();
    initModals();
  }

  ready(init);

  document.addEventListener('shopify:section:load', function () {
    init();
  });
})();